<template>
   
        <div class="guide-expertise">
        <div class="container">
            <div class="app-download-inner m-0">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="app-download-content">
                            <span class="sub-title text-uppercase">Expert Insight</span>
                            <h2>Your Guide to Our Expertise </h2>
                            <p>For a comprehensive overview of our services and how we can help elevate your brand with expertly crafted content, please download our brochure here:.</p>
                          <p>This brochure provides detailed insights into our capabilities, sample works, and how we tailor content strategies to meet your unique business goals.</p>
                            <button @click="openCalendly" class="default-btn">Get in Touch</button>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="app-download-image" data-aos="fade-up">
                            <img src="../../assets/images/app/app-img3.png" alt="app-img">
                        </div>
                    </div>
                </div>
                <div class="shape5">
                    <img src="../../assets/images/shape/shape4.png" alt="shape4">
                </div>
                <div class="lines">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </div> 
</template>